module.exports = ".btn-primary, .btn-primary:hover, .btn-primary:active, .btn-primary:focus {\n    background-color: #e00209;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/upload/upload.component.css
// module id = ./src/app/shared/upload/upload.component.css
// module chunks = main